import { ShieldCheck, ExternalLink, AlertTriangle } from "lucide-react";
import { Layout } from "./LegalPage";
import { getLang } from "../i18n";

const CONTRACT = "0x47935d80e63eddf23f351db33b2363b6925f1530";
const POLYGONSCAN = `https://polygonscan.com/address/${CONTRACT}`;

const copy = {
  it: {
    title: "USTP — Tokenomics e Trasparenza",
    updated: "Universe Score Token Protocol · Polygon",
    s1: {
      title: "Offerta totale",
      p: "USTP (Universe Score Token Protocol) è un token basato sulla blockchain Polygon. L'offerta totale è di 70.000.000.000 USTP, pari a 70 miliardi di token.",
      kv: [
        ["Blockchain", "Polygon"],
        ["Token", "USTP / Universe Score Token Protocol"],
        ["Offerta totale", "70 miliardi di USTP"],
      ],
      contract: "Smart contract",
    },
    s2: { title: "Distribuzione gratuita", p: "2% della Total supply disponibile gratuitamente a singoli portafogli, distribuiti in numero di 1,5 mln di USTP ognuno." },
    s3: { title: "Pre-ICO / Angel Investors", p: "Il 3% della Total supply ad Angel Investors prima della fase ICO." },
    s4: {
      title: "ICO — Gennaio 2027",
      p1: "Durante l'ICO, il progetto prevede di rendere disponibili per lo scambio MATIC/USTP fino a 7.000.000.000 USTP, equivalenti al 10% dell'offerta totale.",
      priceLabel: "Prezzo orientativo ICO (USDT)",
      priceValue: "0,000026360000 USDT per USTP",
      priceNote: "Prezzo indicativo previsto per l'ICO di gennaio 2027.",
      p2: "Il prezzo è indicativo e potrà essere soggetto alle condizioni operative definitive dell'ICO.",
      p3: "La data di avvio, le modalità di partecipazione e le condizioni definitive saranno comunicate attraverso i canali ufficiali di USTP.",
    },
    s5: {
      title: "Allocazione del fondatore",
      p1: "Il fondatore detiene attualmente, secondo i dati dichiarati dal progetto, circa il 94% dell'offerta totale.",
      p2: "Questa concentrazione viene dichiarata apertamente per consentire a chi valuta USTP di comprendere come verranno distribuiti i token USTP.",
      p3: "La destinazione dei token USTP è la seguente:",
      rows: [
        ["5%", "Team sviluppatore (token già consegnati)"],
        ["2%", "Regali / omaggio ai simpatizzanti"],
        ["3%", "Angel Investors (Pre-ICO)"],
        ["10%", "Fase ICO"],
        ["10%", "Partner music publishing"],
        ["10%", "Soci / partners strategici"],
        ["10%", "Pool di liquidità"],
        ["10%", "Fondo di riserva"],
        ["40%", "Nella disponibilità del Fondatore"],
      ],
    },
    s6: {
      title: "Allocazione dello sviluppatore",
      p: [
        "Allo sviluppatore sono stati destinati 3.500.000.000 USTP, pari al 5% dell'offerta totale.",
        "Questa quantità è inclusa nella distribuzione attuale indicata in questa pagina.",
        "Eventuali modifiche o condizioni particolari relative a questa allocazione saranno comunicate separatamente, se formalizzate.",
      ],
    },
    s7: {
      title: "Distribuzione delle commissioni / Exchanges",
      p1: "Allorché inizierà la fase di collocazione di USTP negli Exchange, verrà fissata una commissione del 3% in acquisto e 3% in vendita.",
      p2: "La distribuzione di tali commissioni avverrà nel modo seguente:",
      rows: [
        ["25%", "Team / spese amministrative"],
        ["25%", "Dividendi a tutti i portafogli di USTP (staking)"],
        ["25%", "Pool di liquidità"],
        ["25%", "Acquisto sistematico di BTC"],
      ],
    },
    s8: {
      title: "Verifica sulla blockchain",
      p1: "USTP promuove la trasparenza e invita chiunque sia interessato a verificare le informazioni disponibili pubblicamente.",
      contractLabel: "Indirizzo dello smart contract",
      poly: "Consulta PolygonScan",
      p2: "Attraverso PolygonScan è possibile consultare le informazioni disponibili sul contratto, i trasferimenti e i saldi dei portafogli.",
    },
    s9: {
      title: "Liquidità e rischi",
      p: [
        "Il numero totale di token non determina da solo il prezzo di mercato.",
        "Il prezzo di USTP, qualora venga scambiato, dipenderà anche dalla domanda, dalla liquidità disponibile, dall'attività di scambio e dalle condizioni generali del mercato.",
        "La disponibilità di token per l'ICO non garantisce una vendita completa, una quotazione su exchange, un determinato volume di scambio o un rendimento futuro.",
      ],
    },
    s10: {
      title: "Aggiornamenti del progetto",
      p: [
        "Le informazioni relative alla distribuzione dei token, all'ICO, alle modalità di scambio e agli eventuali sviluppi futuri saranno aggiornate attraverso i canali ufficiali di USTP.",
        "Questa pagina descrive la distribuzione dichiarata e il programma previsto per l'ICO di gennaio 2027. La data effettiva di avvio e le condizioni definitive saranno comunicate ufficialmente.",
      ],
    },
    s11: {
      title: "Avvertenza",
      warn: "Le informazioni contenute in questa pagina hanno finalità informative e non costituiscono consulenza finanziaria, legale o fiscale. Non vengono garantiti profitti, né un prezzo futuro.",
    },
    commit: {
      title: "Il nostro impegno per la trasparenza",
      p1: "USTP intende comunicare in modo chiaro l'offerta totale, la distribuzione dei token e le modalità previste per l'ICO.",
      p2: "La trasparenza è alla base di un rapporto corretto con la comunità USTP.",
    },
  },
  en: {
    title: "USTP — Tokenomics and Transparency",
    updated: "Universe Score Token Protocol · Polygon",
    s1: {
      title: "Total supply",
      p: "USTP (Universe Score Token Protocol) is a token based on the Polygon blockchain. The total supply is 70,000,000,000 USTP, equal to 70 billion tokens.",
      kv: [
        ["Blockchain", "Polygon"],
        ["Token", "USTP / Universe Score Token Protocol"],
        ["Total supply", "70 billion USTP"],
      ],
      contract: "Smart contract",
    },
    s2: { title: "Free distribution", p: "2% of the Total supply available free of charge to individual wallets, distributed in amounts of 1.5 million USTP each." },
    s3: { title: "Pre-ICO / Angel Investors", p: "3% of the Total supply to Angel Investors before the ICO phase." },
    s4: {
      title: "ICO — January 2027",
      p1: "During the ICO, the project plans to make available for the MATIC/USTP swap up to 7,000,000,000 USTP, equal to 10% of the total supply.",
      priceLabel: "Indicative ICO price (USDT)",
      priceValue: "0.000026360000 USDT per USTP",
      priceNote: "Indicative price planned for the January 2027 ICO.",
      p2: "The price is indicative and may be subject to the final operating conditions of the ICO.",
      p3: "The start date, participation methods and final conditions will be communicated through USTP's official channels.",
    },
    s5: {
      title: "Founder allocation",
      p1: "The founder currently holds, according to the data declared by the project, approximately 94% of the total supply.",
      p2: "This concentration is openly declared to allow anyone evaluating USTP to understand how the USTP tokens will be distributed.",
      p3: "The allocation of USTP tokens is as follows:",
      rows: [
        ["5%", "Development team (tokens already delivered)"],
        ["2%", "Gifts / giveaways to supporters"],
        ["3%", "Angel Investors (Pre-ICO)"],
        ["10%", "ICO phase"],
        ["10%", "Music publishing partner"],
        ["10%", "Strategic partners / members"],
        ["10%", "Liquidity pool"],
        ["10%", "Reserve fund"],
        ["40%", "Held by the Founder"],
      ],
    },
    s6: {
      title: "Developer allocation",
      p: [
        "3,500,000,000 USTP, equal to 5% of the total supply, have been allocated to the developer.",
        "This amount is included in the current distribution shown on this page.",
        "Any changes or particular conditions relating to this allocation will be communicated separately, if formalised.",
      ],
    },
    s7: {
      title: "Fee distribution / Exchanges",
      p1: "When the phase of listing USTP on Exchanges begins, a fee of 3% on purchase and 3% on sale will be set.",
      p2: "The distribution of these fees will take place as follows:",
      rows: [
        ["25%", "Team / administrative expenses"],
        ["25%", "Dividends to all USTP wallets (staking)"],
        ["25%", "Liquidity pool"],
        ["25%", "Systematic BTC purchase"],
      ],
    },
    s8: {
      title: "Blockchain verification",
      p1: "USTP promotes transparency and invites anyone interested to verify the publicly available information.",
      contractLabel: "Smart contract address",
      poly: "View on PolygonScan",
      p2: "Through PolygonScan it is possible to consult the information available on the contract, the transfers and the wallet balances.",
    },
    s9: {
      title: "Liquidity and risks",
      p: [
        "The total number of tokens does not by itself determine the market price.",
        "The price of USTP, if traded, will also depend on demand, available liquidity, trading activity and general market conditions.",
        "The availability of tokens for the ICO does not guarantee a full sale, a listing on an exchange, a specific trading volume or a future return.",
      ],
    },
    s10: {
      title: "Project updates",
      p: [
        "Information regarding token distribution, the ICO, the swap methods and any future developments will be updated through USTP's official channels.",
        "This page describes the declared distribution and the planned schedule for the January 2027 ICO. The actual start date and final conditions will be communicated officially.",
      ],
    },
    s11: {
      title: "Disclaimer",
      warn: "The information contained on this page is for informational purposes and does not constitute financial, legal or tax advice. No profits, nor a future price, are guaranteed.",
    },
    commit: {
      title: "Our commitment to transparency",
      p1: "USTP intends to communicate clearly the total supply, the token distribution and the methods planned for the ICO.",
      p2: "Transparency is the foundation of a fair relationship with the USTP community.",
    },
  },
};

const Section = ({ n, title, children }) => (
  <section className="border-t border-slate-100 pt-7 first:border-0 first:pt-0" data-testid={`tok-section-${n}`}>
    <h2 className="flex items-baseline gap-3 font-display text-xl sm:text-2xl font-bold text-slate-900">
      <span className="font-mono text-sm text-sky-600">{String(n).padStart(2, "0")}</span>
      {title}
    </h2>
    <div className="mt-4 space-y-4">{children}</div>
  </section>
);

const KV = ({ k, v, mono }) => (
  <div className="flex flex-wrap items-baseline justify-between gap-2 rounded-xl border border-slate-100 bg-[#F8FAFC] px-4 py-3">
    <span className="text-sm font-semibold text-slate-500">{k}</span>
    <span className={`text-sm font-semibold text-slate-900 ${mono ? "font-mono break-all" : ""}`}>{v}</span>
  </div>
);

const AllocTable = ({ rows, testid }) => (
  <div className="overflow-hidden rounded-2xl border border-slate-200" data-testid={testid}>
    {rows.map(([pct, dest], i) => (
      <div key={dest} className={`flex items-center gap-4 px-4 py-3 ${i % 2 ? "bg-[#F8FAFC]" : "bg-white"}`}>
        <span className="w-14 shrink-0 font-mono text-sm font-bold text-sky-700">{pct}</span>
        <span className="text-sm text-slate-800">{dest}</span>
      </div>
    ))}
  </div>
);

export default function TokenomicsPage() {
  const c = copy[getLang()] || copy.it;
  return (
    <Layout title={c.title} updated={c.updated}>
      <div data-testid="tokenomics-content" className="space-y-8">
        <Section n={1} title={c.s1.title}>
          <p>{c.s1.p}</p>
          <div className="space-y-2">
            {c.s1.kv.map(([k, v]) => <KV key={k} k={k} v={v} />)}
            <KV k={c.s1.contract} v={CONTRACT} mono />
          </div>
        </Section>

        <Section n={2} title={c.s2.title}><p>{c.s2.p}</p></Section>

        <Section n={3} title={c.s3.title}><p>{c.s3.p}</p></Section>

        <Section n={4} title={c.s4.title}>
          <p>{c.s4.p1}</p>
          <div className="rounded-2xl border border-sky-200 bg-sky-50 px-5 py-4">
            <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-slate-400">{c.s4.priceLabel}</p>
            <p className="mt-1 text-lg font-bold text-slate-900">{c.s4.priceValue}</p>
            <p className="mt-1 text-xs text-slate-500">{c.s4.priceNote}</p>
          </div>
          <p>{c.s4.p2}</p>
          <p>{c.s4.p3}</p>
        </Section>

        <Section n={5} title={c.s5.title}>
          <p>{c.s5.p1}</p>
          <p>{c.s5.p2}</p>
          <p className="font-semibold text-slate-900">{c.s5.p3}</p>
          <AllocTable rows={c.s5.rows} testid="tok-allocation-table" />
        </Section>

        <Section n={6} title={c.s6.title}>
          {c.s6.p.map((t, i) => <p key={i}>{t}</p>)}
        </Section>

        <Section n={7} title={c.s7.title}>
          <p>{c.s7.p1}</p>
          <p>{c.s7.p2}</p>
          <AllocTable rows={c.s7.rows} testid="tok-fees-table" />
        </Section>

        <Section n={8} title={c.s8.title}>
          <p>{c.s8.p1}</p>
          <div className="rounded-2xl border border-slate-200 bg-white px-5 py-4 shadow-sm">
            <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-slate-400">{c.s8.contractLabel}</p>
            <p className="mt-2 break-all font-mono text-sm font-semibold text-slate-900">{CONTRACT}</p>
            <a
              href={POLYGONSCAN}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="tok-polygonscan-link"
              className="mt-3 inline-flex items-center gap-2 rounded-full bg-slate-900 px-4 py-2 text-sm font-semibold text-white transition-colors hover:bg-sky-600"
            >
              <ExternalLink size={16} />
              {c.s8.poly}
            </a>
          </div>
          <p>{c.s8.p2}</p>
        </Section>

        <Section n={9} title={c.s9.title}>
          {c.s9.p.map((t, i) => <p key={i}>{t}</p>)}
        </Section>

        <Section n={10} title={c.s10.title}>
          {c.s10.p.map((t, i) => <p key={i}>{t}</p>)}
        </Section>

        <Section n={11} title={c.s11.title}>
          <div className="flex items-start gap-3 rounded-2xl border border-amber-200 bg-amber-50 px-5 py-4">
            <AlertTriangle size={20} className="mt-0.5 shrink-0 text-amber-500" />
            <p className="text-sm text-slate-700">{c.s11.warn}</p>
          </div>
        </Section>

        <div className="rounded-3xl border border-sky-200 bg-gradient-to-br from-sky-600 to-sky-800 p-6 sm:p-8 text-white">
          <div className="flex items-center gap-3">
            <ShieldCheck size={22} />
            <h3 className="font-display text-lg font-bold">{c.commit.title}</h3>
          </div>
          <p className="mt-3 text-sm sm:text-base leading-relaxed text-sky-50">{c.commit.p1}</p>
          <p className="mt-2 text-sm sm:text-base leading-relaxed text-sky-50">{c.commit.p2}</p>
        </div>
      </div>
    </Layout>
  );
}
